export default "__VITE_ASSET__yWRJuCKI__"